import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4.028 13.252c-.657 -.972 -1.028 -2.078 -1.028 -3.252c0 -1.804 .878 -3.449 2.319 -4.69m2.49 -1.506a11.066 11.066 0 0 1 4.191 -.804c4.97 0 9 3.134 9 7c0 1.799 -.873 3.44 -2.307 4.68m-2.503 1.517a11.066 11.066 0 0 1 -4.19 .803c-1.913 0 -3.686 -.464 -5.144 -1.255","key":"svg-0"}],["path",{"d":"M3 15a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M5 17c0 1.42 .316 2.805 1 4","key":"svg-2"}],["path",{"d":"M3 3l18 18","key":"svg-3"}]]

const IconLassoOff = createReactComponent('outline', 'lasso-off', 'LassoOff', __iconNode);

export default IconLassoOff;